export default {
  ZH_HK: {
    input: "輸入",
    home_item_line1: "個類型",
    home_item_line2: "道題目",
    home_item_line3: "次答題",
    home_item_line4: "新建學科",
    inputName: "輸入名稱",
    tips: "確認信息",
    beforeDeleted: "確定刪除嗎",
    confirm: "繼續",
    cancel: "關閉"
  },
  zh_cn: {
    input: "输入",
    home_item_line1: "个类型",
    home_item_line2: "道题目",
    home_item_line3: "次答题",
    home_item_line4: "新建学科",
    inputName: "输入名称",
    tips: "确认信息",
    beforeDeleted: "确定删除吗",
    confirm: "继续",
    cancel: "关闭"
  },
  EN: {
    input: "Input",
    home_item_line1: "types",
    home_item_line2: "question bank",
    home_item_line3: "answers",
    home_item_line4: "New Subject",
    inputName: "Enter Name",
    tips: "Confirmation",
    beforeDeleted: "Are you sure you want to delete",
    confirm: "Confirm",
    cancel: "Close"
  },
  es: {
    input: "Entrada",
    home_item_line1: "Uno Tipo",
    home_item_line2: "Dao Título",
    home_item_line3: "Veces Responder preguntas",
    home_item_line4: "Nuevas disciplinas",
    inputName: "Introduzca el nombre",
    tips: "Información de confirmación",
    beforeDeleted: "¿Está seguro de que desea eliminarlo?",
    confirm: "Confirmar",
    cancel: "Cierre"
  }
};
